import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoadingPane } from '@social-solutions/ssg-forms';
import * as authActions from '../auth/auth.actions';
import { LoginModalComponent } from '../login';
import { push } from 'react-router-redux';

export function requireAuthentication(Component, opts = {}) {
  class AuthenticatedComponent extends React.Component {
    componentWillMount() {
      this.verifyAuthentication(this.props);
    }

    componentWillReceiveProps(nextProps) {
      this.verifyAuthentication(nextProps);
    }

    verifyAuthentication(props) {
      const { opts, auth, authActions } = props;
      const { isAuthenticated, isRevoked, isFetching, useLoginModal, currentSession, authToken } = auth;

      if(isRevoked && !opts.withAccessRevoked) {
        return this.redirectToLogin();
      }

      if(!isAuthenticated && !isRevoked && authToken) {
        return authActions.getCurrentSessionFromSecureToken(authToken)
          .then(() => authActions.fetchParticipantInfo())
          .then(participantInfo => {
            if (participantInfo && participantInfo.webVersion === 'new') {
              const { tenant } = props;
              const slug = tenant.currentTenant && tenant.currentTenant.slug;
              const newConnectUrl = process.env.NEW_CONNECT_URL.replace('{slug}', slug);
              window.location.href = `${newConnectUrl}?authToken=${authToken}`;
            }
          })
          .catch(err => {
            this.redirectToLogin();
          });
      }

      if (currentSession && currentSession.session && currentSession.session.type !== 'participant') {
        return this.redirectToLogin();
      }



      if (isAuthenticated) {
        const user = currentSession && currentSession.user;
        if (user && user.webVersion === 'new') {
          const { tenant } = props;
          const slug = tenant.currentTenant && tenant.currentTenant.slug;
          const newConnectUrl = process.env.NEW_CONNECT_URL.replace('{slug}', slug);
          window.location.href = `${newConnectUrl}?authToken=${authToken}`;
          return;
        }
        return;
      }

      if (isFetching) {
        return;
      }

      if (!useLoginModal) {
        return this.redirectToLogin();
      }
    }

    redirectToLogin() {
      const { authActions, routing } = this.props;
      console.log(routing);
      const { pathname } = routing.location;
      authActions.redirectToLogin(pathname);
    }


    redirectToRoot() {
      const { redirect } = this.props;
      redirect('/');
    }

    loadingMessage(message, isError) {
      var loadingState = {
        isLoading: !isError,
        error: isError ? {
          alertLevel: 'error',
          errorCode: 'error',
          errorMessage: message,
        } : null
      }

      return (
        <div className={'ssg-forms-session-loader'}>
          <div className="ssg-forms-session-loader-message">
            <LoadingPane id="session-loader" loadingState={loadingState} loadingMessage={message}/>
          </div>
        </div>
      )
    }

    render() {
      const { login, auth } = this.props;
      const { isFetching: loginFetching, message : loginMessage } = login || {};
      const { isFetching: sessionFetching, isAuthenticated, useLoginModal } = auth;

      if (loginFetching && !useLoginModal) {
        return this.loadingMessage('Logging in...');
      }

      if (sessionFetching && !useLoginModal) {
        return this.loadingMessage('Loading Session...');
      }
      return (
        <div>
          {(isAuthenticated || useLoginModal) ? (
            <div>
              {(!isAuthenticated && useLoginModal) ? (
                <LoginModalComponent message={loginMessage} />
              ) : null}
              <Component {...this.props} />
            </div>
          ) : this.loadingMessage('Loading Session...')}
        </div>
      );
    }
  }

  AuthenticatedComponent.propTypes = {
    auth: PropTypes.any.isRequired,
    login: PropTypes.any,
    authActions: PropTypes.any.isRequired,
    routing: PropTypes.any.isRequired,
    opts: PropTypes.any.isRequired
  }

  function mapStateToProps({ auth, routing, login, tenant }) {
    return {
      auth,
      routing,
      login,
      tenant,
      opts
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      authActions: bindActionCreators(authActions, dispatch),
      redirect: bindActionCreators(push, dispatch)
    };
  }

  return connect(mapStateToProps, mapDispatchToProps)(AuthenticatedComponent)
}



// WEBPACK FOOTER //
// src/auth/require-authentication.js